module.exports = __webpack_public_path__ + "static/img/congratulations.550c9025.png";